import {createStorageManager} from '@sollapay/utils';

const STORAGE_KEY = 'auth:organization';

const storage = () => createStorageManager({prefix: 'sollapay'});

// The web client requires an organization on /authorize (pre_login_prompt), and memory-only tokens lose it on reload.
export function getRememberedOrganization(): string | undefined {
  return storage().getItem(STORAGE_KEY) ?? undefined;
}

export function rememberOrganization(organizationId: string): void {
  storage().setItem(STORAGE_KEY, organizationId);
}

export function clearRememberedOrganization(): void {
  storage().removeItem(STORAGE_KEY);
}
